import { ImportClientsDataStage } from '.';
import { DataImporterStepperHeader } from '../../../../components/data-importer/DataImporterStepperHeader';

interface StepperHeaderProps {
  stage: ImportClientsDataStage;
}

export const StepperHeader = ({ stage }: StepperHeaderProps) => {
  const availableStages: ImportClientsDataStage[] = [`map_client_fields`, `review_addresses`];
  return <DataImporterStepperHeader stage={stage} availableStages={availableStages} />;
};
